const EMAIL = {
  EMAIL: 'blabla@advisa.se',
};

export default EMAIL;
